













import Vue from 'vue';
import RemoteDataSelectInput from './RemoteDataSelectInput.vue';

export default Vue.extend({
  components: {
    RemoteDataSelectInput,
  },
  model: {
    event: `change`,
    prop: `value`,
  },
  props: {
    identifier: {
      default: ``,
      type: String,
    },
    t: {
      required: true,
      type: Object as () => Record<string, string>,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    value: {
      default: `EUR`,
      type: [String, Number],
    },
  },
});
